module.exports = __webpack_public_path__ + "img/brackets_right_layout_icon.9a54361d.svg";